var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-promo-exclusions.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = (lineno = 0, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.product.isMarketPlace",false]));
frame.set("isMarketplace", t_1, true);
if(frame.topLevel) {
context.setVariable("isMarketplace", t_1);
}
if(frame.topLevel) {
context.addExport("isMarketplace", t_1);
}
output += "\n";
if(runtime.contextOrFrameLookup(context, frame, "isMarketplace")) {
output += "<div class=\"o-row\">\n    <div class=\"o-column o-extra-small--12 c-product-promo-exclusions\">\n\n        <p class=\"c-product-promo-exclusions__p\" data-qa-promo-exclusion>\n            ";
output += runtime.suppressValue((lineno = 6, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_excluded_from_promos"])), env.opts.autoescape);
output += "\n        </p>\n\n    </div>\n</div>";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-promo-exclusions.j2"] , dependencies)